var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { color, borderRadius, elevation, spacing, layer } from '../../constants';
var PopoverStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: calc(100% + ", ");\n  ", ";\n  min-width: 180px;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  /* prevent headers or footers with a background color from breaking out over the border radius */\n  overflow: hidden;\n"], ["\n  position: absolute;\n  top: calc(100% + ", ");\n  ", ";\n  min-width: 180px;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  /* prevent headers or footers with a background color from breaking out over the border radius */\n  overflow: hidden;\n"
    /**
     * A popover is `position: absolute` meaning it must be wrapped in a `position: relative` container
     * to render in the correct location. It will render from the bottom right or left of the wrapping
     * component, this works well when wrapped with a [Menu](/packages/components/Menu) component.
     */
])), spacing.extraTight, function (props) { return (props.right !== undefined ? 'right: 0' : 'left: 0'); }, color.pureWhite, borderRadius.large, elevation.contentNavigation, layer.contextNavigation);
/**
 * A popover is `position: absolute` meaning it must be wrapped in a `position: relative` container
 * to render in the correct location. It will render from the bottom right or left of the wrapping
 * component, this works well when wrapped with a [Menu](/packages/components/Menu) component.
 */
export var Popover = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(PopoverStyle, __assign({}, props), children);
};
var templateObject_1;
//# sourceMappingURL=index.js.map